import React from 'react'

const PricingContent = () => {
  return (
    <div className="w-full bg-white py-24 px-4 text-center flex flex-col justify-center" id='Package'>
        <div class='max-w-[1240px] md:max-w-[900px] mx-auto '
            data-aos="fade-up"       
            data-aos-duration="1000"           
            data-aos-easing="ease-in-out">
            <p class="
                      first-line:uppercase first-line:tracking-widest first-line:text-[#00df9a] first-line:font-semibold first-line:text-xl md:first-line:text-2xl 
                      first-letter:text-7xl first-letter:font-semibold first-letter:mr-3 first-letter:float-left first-letter:text-[#00df9a] 
                      text-justify text-gray-800 font-semibold ">
            Learning solutions for organizations of every size. <span className='selection:bg-[#00df9a] selection:text-white'>Train your people in their native language. Get instant access to the International course collection with your Enterprise subscription. Lorem ipsum dolor sit amet consectetur adipisicing elit.</span> 
            </p>
        </div>
    </div>
    
  )
}

export default PricingContent